export default function () {
  document.querySelectorAll(".steps-slider__slide-image").forEach((slide) => {
    slide.style.backgroundImage = `url("${slide.dataset.src}")`;
    slide.style.backgroundSize = "cover";
    slide.style.backgroundPosition = "center";
  });

  document.querySelectorAll(".carousel__image").forEach((image) => {
    image.style.backgroundImage = `url("${image.dataset.src}")`;
    image.style.backgroundSize = "cover";
    image.style.backgroundPosition = "center";
  });

  document.querySelectorAll(".specs-item__face").forEach((spec) => {
    spec.style.backgroundImage = `url("${spec.dataset.photo}")`;
  });
}
